var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10311 16.2311C4.50426 17.6846 5.836 18.752 7.41703 18.752H11.0837C12.9822 18.752 14.5212 17.2129 14.5212 15.3145V7.98112C14.5212 6.40008 13.4538 5.06835 12.0004 4.66719V11.6478C12.0004 14.1791 9.94834 16.2311 7.41703 16.2311H4.10311Z",
    fill: "#1F2024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75037 0.876953C1.85189 0.876953 0.312866 2.41597 0.312866 4.31445V11.6478C0.312866 13.5463 1.85189 15.0853 3.75037 15.0853H7.41703C9.31551 15.0853 10.8545 13.5463 10.8545 11.6478V4.31445C10.8545 2.41597 9.31551 0.876953 7.41703 0.876953H3.75037Z",
    fill: "#1F2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.5f508b8ec86eeb9582ebf082ae7d93b7.svg";
export { ForwardRef as ReactComponent };